import React, { useState, useCallback } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MuiButton from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const ICONS = {
  info:    <InfoOutlinedIcon style={{ color: "#007bff", fontSize: 28, marginRight: 12 }} />,
  warning: <WarningIcon      style={{ color: "#ffc107", fontSize: 28, marginRight: 12 }} />,
  danger:  <ErrorIcon        style={{ color: "#dc3545", fontSize: 28, marginRight: 12 }} />,
  success: <CheckCircleIcon  style={{ color: "#28a745", fontSize: 28, marginRight: 12 }} />,
};

// Message Component
const CSMessage = ({
  isOpen,
  message,
  title = "ClearStone Hub",
  onClose,
  onYes,
  onNo,
  type = "info", // "info" (OK) or "question" (Yes/No)
  messageType = "info" // "info", "warning", "danger", "success"
}) => (
  <Dialog open={!!isOpen} onClose={onClose} aria-labelledby="csmessage-title">
    <DialogTitle id="csmessage-title" disableTypography style={{ backgroundColor: "#f0f0f0" }}>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} style={{ fontSize: "1.875rem", fontWeight: 500 }}>{title}</Box>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon style={{ fontSize: "2rem" }} />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent style={{ paddingBottom: 24, paddingTop: 24 }}>
      <Box display="flex" alignItems="center">
        {ICONS[messageType] || null}
        <div style={{ whiteSpace: "pre-line", flex: 1 }}>{message}</div>
      </Box>
    </DialogContent>
    <DialogActions>
      {type === "question" ? (
        <>
          <MuiButton variant="contained" onClick={onYes} style={{ background: "#0070C0", color: "#fff" }}>Yes</MuiButton>
          <MuiButton onClick={onNo}>No</MuiButton>
        </>
      ) : (
        <MuiButton variant="contained" onClick={onClose} style={{ background: "#0070C0", color: "#fff" }}>OK</MuiButton>
      )}
    </DialogActions>
  </Dialog>
);

// Custom hook to show CSMessage and get result as a promise
export function useCSMessage() {
  const [messageProps, setMessageProps] = useState(null);

  const showMessage = useCallback(
    (options) =>
      new Promise((resolve) => {
        const { type = "info", messageType = "info" } = options || {};
        setMessageProps({
          ...options,
          isOpen: true,
          type,
          messageType,
          onClose: () => {
            setMessageProps(null);
            resolve(undefined); // For OK/info
          },
          onYes: () => {
            setMessageProps(null);
            resolve(true);
          },
          onNo: () => {
            setMessageProps(null);
            resolve(false);
          }
        });
      }),
    []
  );

  const message = messageProps ? <CSMessage {...messageProps} /> : null;

  return [showMessage, message];
}

export default CSMessage;